import { CssBaseline as MuiCssBaseline } from '@mui/material';
import { ThemeProvider as MuiThemeProvider, useColorScheme } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import GoogleAnalytics from '~/components/google/GoogleAnalytics';
import Notifications from '~/components/Notifications';
import SpinnerTw from '~/components/SpinnerTw';
import TooltipContainer from '~/components/TooltipContainer';
import { CommonAppContext, useCommonAppContext, useInitCommonAppState } from '~/shared/contexts/CommonAppContext';
import StandardLayout from '~/shared/layouts/StandardLayout';
import Mountains from '~/shared/svg/Mountains';
import { theme } from '~/sites/coaching/mui/themes';
import { getLcn } from '~/utils/labeled-classnames';
import { CoachingAppContext, useInitCoachingAppState } from '../contexts/app/CoachingAppContext';
import Banner from './layout/Banner';
import SidebarContent from './layout/SidebarContent';
import Footer from './layout/Footer';

export const appConstants = {
}

export const layoutConstants = {
  bannerHeight: 70,
}

function Providers({ children }: { children: React.ReactNode }) {
  const commonAppState = useInitCommonAppState()

  const appState = useInitCoachingAppState();

  return (
    <HelmetProvider>
      <GoogleAnalytics propertyId="G-J5HMS2P1KJ" />
      <CommonAppContext.Provider value={commonAppState}>
        <CoachingAppContext.Provider value={appState}>
          <MuiThemeProvider theme={theme} defaultMode='light'>
            {/* CssBaseline includes global CSS resets and may conflict with TW it also is responsible for light/dark mode defaults, hrm */}
            <MuiCssBaseline />

            {children}
          </MuiThemeProvider>
        </CoachingAppContext.Provider>
      </CommonAppContext.Provider>
    </HelmetProvider>
  )
}

export default function CoachingAppBase() {
  const { mode, setMode } = useColorScheme();
  const { isLoadingSessionUser } = useCommonAppContext()

  if (isLoadingSessionUser) {
    return <SpinnerTw center={true} />;
  }
  const lcn = getLcn({
    coachingApp: '',
  });

  const mainContentStyle = {
  }

  return (
    <Providers>
      <Helmet>
        <title>Ben Lieb &middot; Coaching for Aspiring Humans</title>
        <meta name="description" content="Coaching description" />
      </Helmet>

      <div className={lcn.coachingApp}>

        <div style={mainContentStyle}>
          <StandardLayout
            banner={<Banner />}
            footer={<Footer />}
            sideBarContent={<SidebarContent />}
          />
        </div>

        <Notifications />
        <TooltipContainer />
      </div>
    </Providers>
  );
}